import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { TesteeDTO } from "../dtos/testee.dto";
import { MimeType } from 'src/app/shared/constants';

@Injectable({ providedIn: 'root' })
export class TesteeService {

    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) { }

    getTestees(organizationId?: number): Observable<any> {
        const url = organizationId
            ? `${this.apiUrl}/testee/get-testees?organizationId=${organizationId}`
            : `${this.apiUrl}/testee/get-testees`;
        return this.http.get(url);
    }

    upsertTestee(testee: TesteeDTO): Observable<any> {
        return this.http.post(`${this.apiUrl}/testee`, testee);
    }

    importTestees(formData: any, organizationId: number): Observable<any> {
        return this.http.post(`${this.apiUrl}/testee/import-testees?organizationId=${organizationId}`, formData);
    }

    deleteTestee(testeeId: string): Observable<any> {
        return this.http.delete(`${this.apiUrl}/testee/${testeeId}`);
    }

    deleteTestees(testeeIds: string[]): Observable<any> {
        return this.http.delete(`${this.apiUrl}/testee/delete-testees`, { body: testeeIds });
    }

    getTestee(): Observable<any> {
        return this.http.get(`${this.apiUrl}/testee`);
    }

    exportTesteeLoginDetails(): Observable<any> {
        return this.http.get(`${this.apiUrl}/testee/export-testee-login-details`, {
            responseType: 'blob'
        });
    }
}